/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  VStack,
  chakra,
  keyframes,
  useColorModeValue,
  Stack,
  Card,
  CardBody,
  Text,
  Divider,
  Heading,
  Flex,
  Badge,
  SimpleGrid,
  HStack,
  Collapse,
  Icon,
} from '@chakra-ui/react';
import { useState } from 'react';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import Header from '../../../../../components/Header/Header';
import CardHeaderMobile from '../../../../../components/Mobile/header';
import { IGetRegistration } from '../../../../../services/hooks/Registration/useGetRegistration';
import HeaderSectionMobilePage from '../../../../../components/Mobile/headerSection';
import { TbMessage } from 'react-icons/tb';
import { IExamResults } from '../../../../../services/hooks/CandidateArea/useGetResultByStep';
import ResultStepCard from '../../../../../components/Result/ResultStepCard';
import { TextXS } from '../../../../../components/Text/Index';
import ScoreItemComponent from '../ScoreItemComponent';

const floatIn = keyframes`
  from { opacity: 0; transform: translateY(18px) scale(0.995); }
  to   { opacity: 1; transform: translateY(0px) scale(1); }
`;
const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

interface IOwnProps {
  registration?: IGetRegistration | null;
  result?: IExamResults;
}

const ResultPage: React.FC<IOwnProps> = ({ registration, result }) => {
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  const [expandedEvaluators, setExpandedEvaluators] = useState<{ [key: string]: boolean }>({});

  const toggleEvaluator = (key: string) => {
    setExpandedEvaluators((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isComplexData = (data: any): data is { score: any[]; classification: any[] } => {
    return data && typeof data === 'object' && 'score' in data && 'classification' in data;
  };

  return (
    <Stack h="100dvh" w="100dvw">
      <Stack height="100%" w="100%" top={0} gap={0}>
        <Header showGoBack />
        <VStack mt={0} mx={3} flex={1} overflowY="auto" py={2}>
          <AnimatedBox
            borderRadius="lg"
            boxShadow="lg"
            mx={3}
            p={{ base: 5, md: 10 }}
            borderWidth={'1px'}
            borderColor={borderColor}
            bg="white"
            flex={1}
            display="flex"
            w="full"
          >
            <VStack boxSizing="border-box" flex={1} spacing={2} align="stretch">
              <CardHeaderMobile title="Resultado" subTitle="" />
              <HeaderSectionMobilePage>
                {registration?.selective_process_vacancy?.selective_process?.name}
              </HeaderSectionMobilePage>
              <Card borderRadius="md" shadow="md" mb={4} bg="white">
                <CardBody>
                  <VStack spacing={0} align="start" fontSize="sm">
                    <Stack>
                      <Flex
                        justify={['flex-start', 'flex-start', 'flex-start', 'space-between', 'space-between']}
                        flexDir={['column-reverse', 'column-reverse', 'column-reverse', 'row', 'row']}
                      >
                        <Stack w={'100%'}>
                          <Flex gap={2} flexDir={['column', 'column', 'row', 'row', 'row']}>
                            <TextXS>
                              <strong>Nome: </strong>
                              {registration?.candidate?.user?.full_name || '--'}
                              {registration?.candidate?.social_name && (
                                <TextXS as={'span'}> ({registration?.candidate?.social_name || '--'})</TextXS>
                              )}
                            </TextXS>

                            <TextXS>
                              <strong>{registration?.candidate.is_foreign ? 'Passaporte' : 'CPF'}: </strong>
                              {registration?.candidate.is_foreign
                                ? registration?.candidate.passport_number
                                : registration?.candidate?.cpf || '--'}
                            </TextXS>

                            <TextXS>
                              <strong>Inscrição:</strong> {registration?.registration_code || '--'}
                            </TextXS>
                          </Flex>

                          <TextXS>
                            <strong>Processo seletivo: </strong>
                            {registration?.selective_process_vacancy?.selective_process?.name || '--'}
                          </TextXS>
                          <TextXS>
                            <strong>
                              {registration?.selective_process_vacancy?.cultural_house
                                ? registration?.selective_process_vacancy.class_level
                                  ? 'Turma: '
                                  : 'Turma - Primeira opção: '
                                : 'Vaga: '}
                            </strong>
                            {registration?.selective_process_vacancy?.name || '--'}
                          </TextXS>
                          {registration?.second_vacancy?.name && (
                            <TextXS>
                              <strong>Turma - Segunda opção: </strong>
                              {registration?.second_vacancy?.name || '--'}
                              <TextXS>{registration?.second_vacancy?.details || ''}</TextXS>
                            </TextXS>
                          )}
                        </Stack>
                      </Flex>
                    </Stack>
                  </VStack>
                </CardBody>
              </Card>

              {result?.final && (
                <Card borderRadius="md" shadow="md" mb={4} bg="white">
                  <CardBody>
                    <Flex gap={1} color="green.600">
                      <TbMessage />
                      <Heading size="sm" mb={4}>
                        Resultado final
                      </Heading>
                    </Flex>

                    {isComplexData(result?.final?.data) && (
                      <>
                        {result?.final.data.classification.map((classItem, idx) => {
                          const label = classItem.label.toLowerCase();

                          if (label.includes('ampla concorrência')) {
                            return (
                              <ResultStepCard
                                key={idx}
                                title=""
                                position={classItem.position}
                                status={classItem.status}
                              />
                            );
                          }
                          // && (registration?.type_of_competition?.length ?? 0) > 1
                          if (label.includes('geral')) {
                            return (
                              <ResultStepCard
                                key={idx}
                                title="Classificação geral"
                                position={classItem.position}
                                status={classItem.status}
                              />
                            );
                          }

                          // if (label.includes('pcd')) {
                          //   return (
                          //     <ResultStepCard
                          //       key={idx}
                          //       title="Classificação PCD"
                          //       position={classItem.position}
                          //       status={classItem.status}
                          //     />
                          //   );
                          // }

                          if (label.includes('preto') || label.includes('pardo')) {
                            return (
                              <ResultStepCard
                                key={idx}
                                title="Pretos e pardos"
                                position={classItem.position}
                                status={classItem.status}
                              />
                            );
                          }

                          if (label.includes('segunda') || label.includes('2')) {
                            return (
                              <ResultStepCard
                                key={idx}
                                title="Classificação 2ª opção de turma"
                                position={classItem.position}
                                status={classItem.status}
                              />
                            );
                          }

                          return null;
                        })}
                      </>
                    )}

                    <Box mt={4}>
                      <TextXS fontWeight="bold">Pontuação</TextXS>
                      <Box>
                        {result?.final?.nf && (
                          <TextXS>
                            <strong>Nota da prova:</strong> {result?.final?.nf} pontos
                          </TextXS>
                        )}

                        {result.final?.npo && (
                          <TextXS>
                            <strong>Nota prova objetiva:</strong> {result?.final?.npo} pontos
                          </TextXS>
                        )}
                        {result?.final?.npt && (
                          <TextXS>
                            <strong>Nota prova títulos:</strong> {result?.final?.npt} pontos
                          </TextXS>
                        )}
                        {result?.final?.npd && (
                          <TextXS>
                            <strong>Nota prova Discursiva:</strong> {result?.final?.npd} pontos
                          </TextXS>
                        )}
                        {result?.final?.npr && (
                          <TextXS>
                            <strong>Nota Redação:</strong> {result?.final?.npr} pontos
                          </TextXS>
                        )}
                      </Box>

                      {isComplexData(result?.final?.data) && (
                        <Box mt={2}>
                          <TextXS fontWeight="bold">Pontuação:</TextXS>
                          {result?.final.data.score
                            .sort((a, b) => {
                              if (a.label.toLowerCase().includes('prova')) return -1;
                              if (b.label.toLowerCase().includes('prova')) return 1;
                              return 0;
                            })
                            .map((scoreItem, i) => <ScoreItemComponent key={i} scoreItem={scoreItem} />)}
                        </Box>
                      )}

                      {Array.isArray(result?.final?.data) && (
                        <Box mt={2}>
                          <TextXS fontWeight="bold">Detalhamento:</TextXS>
                          {result?.final?.data.map((dataItem, i) => (
                            <Box key={i} ml={4}>
                              <TextXS>
                                <strong>{dataItem.label}:</strong> {dataItem.points} pontos
                              </TextXS>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {isComplexData(result?.final?.data) &&
                        result?.final?.data.evaluators &&
                        result?.final?.data.evaluators.length > 0 && (
                          <Box mt={3}>
                            <Divider my={2} borderColor={'#bdbdbd'} />
                            <TextXS fontWeight="bold">Notas dos Avaliadores:</TextXS>
                            <Stack spacing={2} mt={2}>
                              {result?.final?.data.evaluators.map((evaluator, i) => {
                                const evaluatorKey = `final-${i}`;
                                const isExpanded = expandedEvaluators[evaluatorKey];
                                const hasDetails = evaluator.penalty?.is_deadline_breached || evaluator.note_justification || (evaluator.criteria && evaluator.criteria.length > 0);

                                return (
                                  <Stack
                                    key={i}
                                    p={3}
                                    borderRadius="lg"
                                    border="1px solid"
                                    borderColor="gray.100"
                                    boxShadow="sm"
                                    transition="all 0.2s"
                                    _hover={{ boxShadow: 'md', cursor: hasDetails ? 'pointer' : 'default' }}
                                    bg={'white'}
                                    onClick={() => hasDetails && toggleEvaluator(evaluatorKey)}
                                  >
                                    <Flex justify={'space-between'} align="center">
                                      <Flex align="center" gap={2} flex={1}>
                                        {hasDetails && (
                                          <Icon as={isExpanded ? IoChevronUp : IoChevronDown} boxSize={5} color="gray.500" />
                                        )}
                                        <TextXS fontWeight={'bold'} color="gray.700">
                                          {evaluator.evaluator_name}
                                        </TextXS>
                                      </Flex>
                                      <Badge
                                        colorScheme={'green'}
                                        variant="subtle"
                                        px={2}
                                        py={1}
                                        borderRadius="md"
                                        fontSize="xs"
                                      >
                                        {evaluator.penalty?.is_deadline_breached 
                                          ? evaluator.penalty.final_score_with_penalty 
                                          : evaluator.normalized_score} pontos
                                      </Badge>
                                    </Flex>

                                    <Collapse in={isExpanded} animateOpacity>
                                      {evaluator.penalty?.is_deadline_breached && (
                                        <Box mt={2} p={2} bg="red.50" borderRadius="md" borderLeft="3px solid" borderColor="red.400">
                                          <TextXS fontWeight="bold" color="red.700" mb={1}>
                                            ⚠️ Penalidade Aplicada
                                          </TextXS>
                                          <TextXS color="gray.700">
                                            <strong>Tempo excedido:</strong> {evaluator.penalty.quantity_in_minute} minuto(s)
                                          </TextXS>
                                          <TextXS color="gray.700">
                                            <strong>Pontos descontados:</strong> {evaluator.penalty.penalty_applied} pontos
                                          </TextXS>
                                          <TextXS color="gray.700">
                                            <strong>Nota antes da penalidade:</strong> {evaluator.grade} pontos
                                          </TextXS>
                                        </Box>
                                      )}

                                      {evaluator.note_justification && (
                                        <Box mt={2} p={2} bg="blue.50" borderRadius="md">
                                          <TextXS fontWeight="bold" color="blue.700" mb={1}>
                                            Justificativa:
                                          </TextXS>
                                          <TextXS color="gray.700" whiteSpace="pre-wrap">
                                            {evaluator.note_justification}
                                          </TextXS>
                                        </Box>
                                      )}

                                      {evaluator.criteria && evaluator.criteria.length > 0 && (
                                        <Box mt={2} p={2} bg="gray.50" borderRadius="md">
                                          <TextXS fontWeight="bold" color="gray.700" mb={2}>
                                            Critérios de Avaliação:
                                          </TextXS>
                                          <Stack spacing={2}>
                                            {evaluator.criteria.map((criterion, idx) => (
                                              <Box 
                                                key={idx} 
                                                p={2} 
                                                bg="white" 
                                                borderRadius="md" 
                                                borderLeft="2px solid" 
                                                borderColor="blue.400"
                                              >
                                                <TextXS fontWeight="semibold" color="gray.800" mb={1}>
                                                  {criterion.criterion_name}
                                                </TextXS>
                                                <Flex justify="space-between" align="center">
                                                  <TextXS color="gray.600">
                                                    Pontuação atribuída:
                                                  </TextXS>
                                                  <Badge colorScheme="blue" fontSize="xs">
                                                    {criterion.points_awarded}
                                                  </Badge>
                                                </Flex>
                                                {criterion.observation && (
                                                  <TextXS color="gray.600" mt={1} fontSize="xs" fontStyle="italic">
                                                    Obs: {criterion.observation}
                                                  </TextXS>
                                                )}
                                              </Box>
                                            ))}
                                          </Stack>
                                        </Box>
                                      )}
                                    </Collapse>
                                  </Stack>
                                );
                              })}
                            </Stack>
                          </Box>
                        )}
                    </Box>

                    <Divider my={5} />
                  </CardBody>
                </Card>
              )}

              <Stack border={'none'} p={0}>
                <Flex gap={1} color="blue.600">
                  <Heading px={2} size="sm">
                    Resultados por etapa
                  </Heading>
                </Flex>

                <SimpleGrid columns={[1, 1, 1, 3, 3]} spacing={5}>
                  {result?.steps.length === 0 ? (
                    <Flex justify="center" py={3}>
                      <Text color="gray.500">Sem resultados para exibição</Text>
                    </Flex>
                  ) : (
                    result?.steps.map((item, index) => {
                      let columnsGrid = 1;

                      if (isComplexData(item.data) && item.data.classification) {
                        columnsGrid =
                          Array.isArray(item?.data?.classification) && item?.data?.classification?.length === 1 ? 1 : 2;

                        const hasGeral = item.data.classification.some((item) =>
                          item.label.toLowerCase().includes('geral'),
                        );

                        const qtdCompetitions = (registration?.type_of_competition?.length ?? 0) > 1;

                        if (hasGeral && !qtdCompetitions) columnsGrid -= 1;
                      }

                      return (
                        <Box bg={'#fcfcfc'} key={index} w={'100%'} borderRadius="xl" px={4} pt={2} shadow="md">
                          <Box>
                            <Flex
                              justify={['flex-start', 'flex-start', 'space-between', 'space-between', 'space-between']}
                              direction={['column', 'column', 'row', 'row', 'row']}
                            >
                              <Text fontWeight={'bold'} fontSize="16px" mb={2}>
                                {item.name}
                              </Text>
                              <Badge mb={2} w={'fit-content'} h={'fit-content'} colorScheme="blue">
                                {' '}
                                Resultado {item.type}
                              </Badge>
                            </Flex>

                            <Divider mb={4} borderColor={'#555555'} />
                          </Box>

                          {isComplexData(item.data) ? (
                            <>
                              <Text mb={2} textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold">
                                Classificação
                              </Text>
                              <SimpleGrid columns={[1, 1, 1, columnsGrid]} spacing={1}>
                                {[...item.data.classification]
                                  .sort((a, b) => {
                                    const aIsGeral = a.label.toLowerCase().includes('geral');
                                    const bIsGeral = b.label.toLowerCase().includes('geral');
                                    if (aIsGeral && !bIsGeral) return -1;
                                    if (!aIsGeral && bIsGeral) return 1;
                                    return 0;
                                  })
                                  .map((classItem, idx) => {
                                  const label = classItem.label.toLowerCase();

                                  const showReserved =
                                    item.type === 'Preliminar'
                                      ? item.show_reserved_vacancies_preliminary_result
                                      : item.show_reserved_vacancies_final_result;

                                  if (label.includes('geral')) {
                                    const isPracticalTest = item.name.toLowerCase().includes('prática') || item.name.toLowerCase().includes('pratica');
                                    return (
                                      <ResultStepCard
                                        key={idx}
                                        title={isPracticalTest ? 'Classificação Geral' : 'Ampla Concorrência'}
                                        position={classItem.position}
                                        status={classItem.status}
                                      />
                                    );
                                  }

                                  if (showReserved && label.includes('pcd')) {
                                    return (
                                      <ResultStepCard
                                        key={idx}
                                        title="PCD"
                                        position={classItem.position}
                                        status={classItem.status}
                                      />
                                    );
                                  }

                                  if (showReserved && (label.includes('ppiq') || label.includes('pppiq') || label.includes('preto') || label.includes('pardo'))) {
                                    return (
                                      <ResultStepCard
                                        key={idx}
                                        title="PPPIQ"
                                        position={classItem.position}
                                        status={classItem.status}
                                      />
                                    );
                                  }

                                  if (label.includes('segunda') || label.includes('2')) {
                                    return (
                                      <ResultStepCard
                                        key={idx}
                                        title="Classificação 2ª opção de turma"
                                        position={classItem.position}
                                        status={classItem.status}
                                      />
                                    );
                                  }

                                  return null;
                                })}
                              </SimpleGrid>

                              <Divider py={2} borderColor={'#bdbdbd'} />

                              {isComplexData(item.data) && (
                                <Box mt={3}>
                                  <Text textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold">
                                    Pontuação
                                  </Text>
                                  <Stack p={0} m={0} mb={2}>
                                    {item.data.score
                                      .sort((a, b) => {
                                        if (a.label.toLowerCase().includes('prova')) return 1;
                                        if (b.label.toLowerCase().includes('prova')) return -1;
                                        return 0;
                                      })
                                      .map((scoreItem, i) => (
                                        <ScoreItemComponent key={i} scoreItem={scoreItem} />
                                      ))}
                                  </Stack>
                                </Box>
                              )}

                              {isComplexData(item.data) && item.data.evaluators && item.data.evaluators.length > 0 && (
                                <Box mt={3}>
                                  <Divider py={2} borderColor={'#bdbdbd'} />
                                  <Text
                                    mt={3}
                                    textAlign={'center'}
                                    fontSize={'15px'}
                                    color="gray.700"
                                    fontWeight="bold"
                                  >
                                    Notas dos Avaliadores
                                  </Text>
                                  <Stack p={0} m={0} mb={2} spacing={2}>
                                    {item.data.evaluators.map((evaluator, i) => {
                                      const evaluatorKey = `step-${index}-${i}`;
                                      const isExpanded = expandedEvaluators[evaluatorKey];
                                      const hasDetails = evaluator.penalty?.is_deadline_breached || evaluator.note_justification || (evaluator.criteria && evaluator.criteria.length > 0);

                                      return (
                                        <Stack
                                          key={i}
                                          p={3}
                                          borderRadius="lg"
                                          border="1px solid"
                                          borderColor="gray.100"
                                          boxShadow="sm"
                                          transition="all 0.2s"
                                          _hover={{ boxShadow: 'md', cursor: hasDetails ? 'pointer' : 'default' }}
                                          bg={'white'}
                                          onClick={() => hasDetails && toggleEvaluator(evaluatorKey)}
                                        >
                                          <Flex justify={'space-between'} align="center">
                                            <Flex align="center" gap={2} flex={1}>
                                              {hasDetails && (
                                                <Icon as={isExpanded ? IoChevronUp : IoChevronDown} boxSize={5} color="gray.500" />
                                              )}
                                              <TextXS fontWeight={'bold'} color="gray.700">
                                                {evaluator.evaluator_name}
                                              </TextXS>
                                            </Flex>
                                            <Badge
                                              colorScheme={'green'}
                                              variant="subtle"
                                              px={2}
                                              py={1}
                                              borderRadius="md"
                                              fontSize="xs"
                                            >
                                              {evaluator.penalty?.is_deadline_breached 
                                                ? evaluator.penalty.final_score_with_penalty 
                                                : evaluator.normalized_score} pontos
                                            </Badge>
                                          </Flex>

                                          <Collapse in={isExpanded} animateOpacity>
                                            {evaluator.penalty?.is_deadline_breached && (
                                              <Box mt={2} p={2} bg="red.50" borderRadius="md" borderLeft="3px solid" borderColor="red.400">
                                                <TextXS fontWeight="bold" color="red.700" mb={1}>
                                                  ⚠️ Penalidade Aplicada
                                                </TextXS>
                                                <TextXS color="gray.700">
                                                  <strong>Tempo excedido:</strong> {evaluator.penalty.quantity_in_minute} minuto(s)
                                                </TextXS>
                                                <TextXS color="gray.700">
                                                  <strong>Pontos descontados:</strong> {evaluator.penalty.penalty_applied} pontos
                                                </TextXS>
                                                <TextXS color="gray.700">
                                                  <strong>Nota antes da penalidade:</strong> {evaluator.grade} pontos
                                                </TextXS>
                                              </Box>
                                            )}

                                            {evaluator.note_justification && (
                                              <Box mt={2} p={2} bg="blue.50" borderRadius="md">
                                                <TextXS fontWeight="bold" color="blue.700" mb={1}>
                                                  Justificativa:
                                                </TextXS>
                                                <TextXS color="gray.700" whiteSpace="pre-wrap">
                                                  {evaluator.note_justification}
                                                </TextXS>
                                              </Box>
                                            )}

                                            {evaluator.criteria && evaluator.criteria.length > 0 && (
                                              <Box mt={2} p={2} bg="gray.50" borderRadius="md">
                                                <TextXS fontWeight="bold" color="gray.700" mb={2}>
                                                  Critérios de Avaliação:
                                                </TextXS>
                                                <Stack spacing={2}>
                                                  {evaluator.criteria.map((criterion, idx) => (
                                                    <Box 
                                                      key={idx} 
                                                      p={2} 
                                                      bg="white" 
                                                      borderRadius="md" 
                                                      borderLeft="2px solid" 
                                                      borderColor="blue.400"
                                                    >
                                                      <TextXS fontWeight="semibold" color="gray.800" mb={1}>
                                                        {criterion.criterion_name}
                                                      </TextXS>
                                                      <Flex justify="space-between" align="center">
                                                        <TextXS color="gray.600">
                                                          Pontuação atribuída:
                                                        </TextXS>
                                                        <Badge colorScheme="blue" fontSize="xs">
                                                          {criterion.points_awarded}
                                                        </Badge>
                                                      </Flex>
                                                      {criterion.observation && (
                                                        <TextXS color="gray.600" mt={1} fontSize="xs" fontStyle="italic">
                                                          Obs: {criterion.observation}
                                                        </TextXS>
                                                      )}
                                                    </Box>
                                                  ))}
                                                </Stack>
                                              </Box>
                                            )}
                                          </Collapse>
                                        </Stack>
                                      );
                                    })}
                                  </Stack>
                                </Box>
                              )}
                            </>
                          ) : (
                            <>
                              {(item.proof_type === 'heteroidentification' ||
                                item.proof_type === 'biopsychosocial_test') && (
                                <>
                                  <Text textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold">
                                    Resultado da análise da etapa
                                  </Text>
                                  <HStack justify={'center'} mt={4} mb={4} align="center" spacing={2}>
                                    <Text fontWeight="medium" color="gray.600">
                                      Situação:
                                    </Text>
                                    <Badge
                                      size="lg"
                                      variant="subtle"
                                      colorScheme={
                                        !Array.isArray(item.data) &&
                                        item.data &&
                                        'status' in (item.data as any) &&
                                        (item.data as any).status === 'deferido'
                                          ? 'green'
                                          : !Array.isArray(item.data) &&
                                              item.data &&
                                              'status' in (item.data as any) &&
                                              (item.data as any).status === 'indeferido'
                                            ? 'red'
                                            : 'gray'
                                      }
                                      px={3}
                                      py={1}
                                      borderRadius="5px"
                                      fontSize="12px"
                                      fontWeight="bold"
                                      textTransform="uppercase"
                                    >
                                      {(item.data as any)?.status}
                                    </Badge>
                                  </HStack>
                                </>
                              )}

                              {/* CARD PARA TAF E TAT   */}
                              {item.proof_type === 'aptitude' && (() => {
                                const aptitudeData = !Array.isArray(item.data) && item.data ? (item.data as any) : null;
                                const aptitudeStatus = aptitudeData?.status;
                                const isFitUnfit = aptitudeStatus === 'fit' || aptitudeStatus === 'unfit';

                                if (isFitUnfit) {
                                  return (
                                    <>
                                      <Text textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold">
                                        Resultado da análise da etapa
                                      </Text>
                                      <HStack justify={'center'} mt={4} mb={4} align="center" spacing={2}>
                                        <Text fontWeight="medium" color="gray.600">
                                          Situação:
                                        </Text>
                                        <Badge
                                          size="lg"
                                          variant="subtle"
                                          colorScheme={aptitudeStatus === 'fit' ? 'green' : 'red'}
                                          px={3}
                                          py={1}
                                          borderRadius="5px"
                                          fontSize="12px"
                                          fontWeight="bold"
                                          textTransform="uppercase"
                                        >
                                          {aptitudeStatus === 'fit' ? 'APTO' : 'INAPTO'}
                                        </Badge>
                                      </HStack>
                                    </>
                                  );
                                }

                                return (
                                  <>
                                    <Text mb={2} textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold">
                                      Classificação
                                    </Text>
                                    <ResultStepCard
                                      title={item.name.toLowerCase().includes('prática') || item.name.toLowerCase().includes('pratica') ? 'Classificação Geral' : 'Ampla Concorrência'}
                                      position={aptitudeData?.position}
                                      status={aptitudeData?.status_label || aptitudeStatus}
                                    />

                                    {aptitudeData?.score?.proof?.points != null && (
                                      <Box mt={3}>
                                        <Divider py={2} borderColor={'#bdbdbd'} />
                                        <Text textAlign={'center'} fontSize={'15px'} color="gray.700" fontWeight="bold" mt={2}>
                                          Pontuação
                                        </Text>
                                        <Stack p={0} m={0} mb={2}>
                                          <ScoreItemComponent
                                            scoreItem={{
                                              correction_mode: 'proof',
                                              label: 'Prova',
                                              points: aptitudeData.score.proof.points,
                                              details: {},
                                            }}
                                          />
                                        </Stack>
                                      </Box>
                                    )}
                                  </>
                                );
                              })()}

                              {/* TITULOS */}
                              {item.proof_type == 'titles' && (() => {
                                const titlesData = item.data as any;
                                const isNewTitlesFormat =
                                  titlesData &&
                                  !Array.isArray(titlesData) &&
                                  titlesData.categories;

                                if (isNewTitlesFormat) {
                                  const totalPoints = titlesData.score?.points ?? 0;
                                  return (
                                    <Stack mt={2} spacing={3}>
                                      {/* Pontuação total */}
                                      <Flex
                                        justify="space-between"
                                        align="center"
                                        bg="purple.50"
                                        p={3}
                                        borderRadius="lg"
                                        border="1px solid"
                                        borderColor="purple.200"
                                      >
                                        <Text fontSize="sm" fontWeight="bold" color="purple.700">
                                          Pontuação Final
                                        </Text>
                                        <Badge
                                          colorScheme="purple"
                                          fontSize="sm"
                                          px={3}
                                          py={1}
                                          borderRadius="md"
                                        >
                                          {totalPoints} pontos
                                        </Badge>
                                      </Flex>

                                      {/* Categorias */}
                                      {titlesData.categories.map((category: any, catIdx: number) => {
                                        const catKey = `titles-${index}-cat-${catIdx}`;
                                        const isCatExpanded = expandedEvaluators[catKey] ?? true;

                                        return (
                                          <Box
                                            key={catIdx}
                                            border="1px solid"
                                            borderColor="gray.200"
                                            borderRadius="lg"
                                            overflow="hidden"
                                          >
                                            {/* Cabeçalho da categoria */}
                                            <Flex
                                              justify="space-between"
                                              align="center"
                                              p={3}
                                              bg="blue.50"
                                              cursor="pointer"
                                              onClick={() => toggleEvaluator(catKey)}
                                            >
                                              <Text
                                                fontWeight="bold"
                                                fontSize="xs"
                                                color="blue.800"
                                                flex={1}
                                                pr={2}
                                              >
                                                {category.name}
                                              </Text>
                                              <Flex align="center" gap={2} flexShrink={0}>
                                                <Badge
                                                  colorScheme="blue"
                                                  px={2}
                                                  py={1}
                                                  borderRadius="md"
                                                  fontSize="xs"
                                                >
                                                  {category.awarded_score_decimal} pts
                                                </Badge>
                                                <Icon
                                                  as={isCatExpanded ? IoChevronUp : IoChevronDown}
                                                  boxSize={4}
                                                  color="blue.600"
                                                />
                                              </Flex>
                                            </Flex>

                                            <Collapse in={isCatExpanded} animateOpacity>
                                              <Stack p={3} spacing={2}>
                                                {category.items.map((titleItem: any, itemIdx: number) => {
                                                  const itemKey = `titles-${index}-cat-${catIdx}-item-${itemIdx}`;
                                                  const isItemExpanded = expandedEvaluators[itemKey];
                                                  const hasJustification =
                                                    titleItem.justification &&
                                                    titleItem.justification.trim() !== '';
                                                  const decisionColor =
                                                    titleItem.decision === 'approved'
                                                      ? 'green'
                                                      : titleItem.decision === 'adjusted'
                                                        ? 'orange'
                                                        : 'red';

                                                  return (
                                                    <Box
                                                      key={itemIdx}
                                                      border="1px solid"
                                                      borderColor="gray.100"
                                                      borderRadius="md"
                                                      p={3}
                                                      bg="white"
                                                      boxShadow="sm"
                                                    >
                                                      <Flex justify="space-between" align="start" gap={2}>
                                                        <Text
                                                          fontSize="xs"
                                                          fontWeight="medium"
                                                          color="gray.700"
                                                          flex={1}
                                                        >
                                                          {titleItem.name}
                                                        </Text>
                                                        <Badge
                                                          colorScheme={decisionColor}
                                                          fontSize="xs"
                                                          px={2}
                                                          py={0.5}
                                                          borderRadius="md"
                                                          flexShrink={0}
                                                        >
                                                          {titleItem.decision_label}
                                                        </Badge>
                                                      </Flex>



                                                      {hasJustification && (
                                                        <>
                                                          <Box
                                                            mt={2}
                                                            cursor="pointer"
                                                            onClick={() => toggleEvaluator(itemKey)}
                                                          >
                                                            <Flex align="center" gap={1}>
                                                              <Icon
                                                                as={
                                                                  isItemExpanded
                                                                    ? IoChevronUp
                                                                    : IoChevronDown
                                                                }
                                                                boxSize={3}
                                                                color="gray.500"
                                                              />
                                                              <TextXS color="blue.600" fontSize="xs">
                                                                Ver justificativa
                                                              </TextXS>
                                                            </Flex>
                                                          </Box>
                                                          <Collapse in={isItemExpanded} animateOpacity>
                                                            <Box
                                                              mt={2}
                                                              p={2}
                                                              bg={
                                                                titleItem.decision === 'rejected'
                                                                  ? 'red.50'
                                                                  : 'orange.50'
                                                              }
                                                              borderRadius="md"
                                                              borderLeft="3px solid"
                                                              borderColor={`${decisionColor}.400`}
                                                            >
                                                              <TextXS
                                                                color="gray.700"
                                                                whiteSpace="pre-wrap"
                                                                fontSize="xs"
                                                              >
                                                                {titleItem.justification}
                                                              </TextXS>
                                                            </Box>
                                                          </Collapse>
                                                        </>
                                                      )}
                                                    </Box>
                                                  );
                                                })}
                                              </Stack>
                                            </Collapse>
                                          </Box>
                                        );
                                      })}
                                    </Stack>
                                  );
                                }

                                // Formato legado: array com label/points
                                return (
                                  <Stack mt={2}>
                                    <Text
                                      textAlign={'center'}
                                      fontSize={'15px'}
                                      color="gray.700"
                                      fontWeight="bold"
                                    >
                                      Pontuação
                                    </Text>
                                    {Array.isArray(titlesData) &&
                                      titlesData
                                        .slice()
                                        .sort((a: any, b: any) => {
                                          const aIsProva = a.label?.toLowerCase().includes('prova');
                                          const bIsProva = b.label?.toLowerCase().includes('prova');
                                          if (aIsProva && !bIsProva) return 1;
                                          if (!aIsProva && bIsProva) return -1;
                                          return 0;
                                        })
                                        .map((dataItem: any, i: number) => {
                                          if (dataItem.label && typeof dataItem.points !== 'undefined') {
                                            return (
                                              <Stack
                                                key={i}
                                                p={3}
                                                borderRadius="lg"
                                                border="1px solid"
                                                borderColor="gray.100"
                                                boxShadow="sm"
                                                transition="all 0.2s"
                                                _hover={{ boxShadow: 'md' }}
                                                justify={'space-between'}
                                                bg={'white'}
                                              >
                                                <Flex justify={'space-between'}>
                                                  <TextXS
                                                    display="flex"
                                                    alignItems="center"
                                                    gap={2}
                                                    fontWeight={'bold'}
                                                    color="gray.700"
                                                  >
                                                    {dataItem.label.toLowerCase().includes('prova')
                                                      ? 'Nota da prova'
                                                      : dataItem.label}
                                                  </TextXS>
                                                  <Flex gap={2}>
                                                    <Badge
                                                      colorScheme={'blue'}
                                                      variant="subtle"
                                                      px={2}
                                                      py={1}
                                                      borderRadius="md"
                                                      fontSize="xs"
                                                    >
                                                      {dataItem.points} ponto{dataItem.points > 1 ? 's' : ''}
                                                    </Badge>
                                                  </Flex>
                                                </Flex>
                                              </Stack>
                                            );
                                          }
                                          return null;
                                        })}
                                  </Stack>
                                );
                              })()}
                            </>
                          )}
                        </Box>
                      );
                    })
                  )}
                </SimpleGrid>
              </Stack>
            </VStack>
          </AnimatedBox>
        </VStack>
      </Stack>
    </Stack>
  );
};

export default ResultPage;
